const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const RpaQuery: any = {
    startRpaProcess: Backofficebff + '/v1/rpasender/process-rpa-by-shipping-list-no',
    startListOfRpaProcess: Backofficebff + '/v1/rpasender/process-rpa-by-list-of-shipping-list-no',
    rpaRequestList: Backofficebff + '/v1/rpasender/rpa-request-list',
    rpaActionList: Backofficebff + '/v1/rpasender/rpa-action-list',
};
